import React, { useMemo } from 'react';
import GridDrag from '../../../../GridDrag';
import AspectRatio from '../../../../AspectRatio';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { useGetProjectListByIds } from '../../../../../hooks/api/useGetProjectListByIds';
import { getProjectImages } from "../../postblocks/ProjectsBlock/components/projectItem";
import useLocalization from "../../../../../hooks/useLocalization";
import { WIDE_PRESENTATION_RATIO } from '../../../../../constants/media';
// @ts-ignore
export var ProjectEditBlock = function (_a) {
    var projectIds = _a.projectIds, onSetSortedProject = _a.onSetSortedProject, onDeleteProject = _a.onDeleteProject;
    // @ts-ignore
    var fixedRatio = useCommonProps().fixedRatio;
    // const maxProjects = useMemo(() => (fixedRatio || 1.8) === 1.8 ? 3 : 2, [fixedRatio]);
    // @ts-ignore
    var projects = useGetProjectListByIds(projectIds).projects;
    // @ts-ignore
    var language = useLocalization().language;
    var srcList = useMemo(function () {
        return (projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return ({
            id: project === null || project === void 0 ? void 0 : project.projectId,
            files: getProjectImages(project, language),
            isUploaded: true,
            // @ts-ignore
            isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'free-type'].includes(project === null || project === void 0 ? void 0 : project.projectType)
        }); })) || [];
    }, [projects]);
    return (
    // @ts-ignore
    React.createElement(AspectRatio, { ratio: fixedRatio || WIDE_PRESENTATION_RATIO },
        React.createElement(GridDrag, { isProjectDrag: true, columnsNum: ((srcList === null || srcList === void 0 ? void 0 : srcList.length) === 1 && (srcList === null || srcList === void 0 ? void 0 : srcList.some(function (item) { return item === null || item === void 0 ? void 0 : item.isPresentation; }))) ? 1 : undefined, list: srcList, onSetSortedImg: onSetSortedProject, onImgRemove: onDeleteProject })));
};
//# sourceMappingURL=ProjectEditBlock.js.mapimport React, { useMemo } from 'react';
import GridDrag from '../../../../GridDrag';
import AspectRatio from '../../../../AspectRatio';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { useGetProjectListByIds } from '../../../../../hooks/api/useGetProjectListByIds';
import { getProjectImages } from "../../postblocks/ProjectsBlock/components/projectItem";
import useLocalization from "../../../../../hooks/useLocalization";
import { WIDE_PRESENTATION_RATIO } from '../../../../../constants/media';
// @ts-ignore
export var ProjectEditBlock = function (_a) {
    var projectIds = _a.projectIds, onSetSortedProject = _a.onSetSortedProject, onDeleteProject = _a.onDeleteProject;
    // @ts-ignore
    var fixedRatio = useCommonProps().fixedRatio;
    // const maxProjects = useMemo(() => (fixedRatio || 1.8) === 1.8 ? 3 : 2, [fixedRatio]);
    // @ts-ignore
    var projects = useGetProjectListByIds(projectIds).projects;
    // @ts-ignore
    var language = useLocalization().language;
    var srcList = useMemo(function () {
        return (projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return ({
            id: project === null || project === void 0 ? void 0 : project.projectId,
            files: getProjectImages(project, language),
            isUploaded: true,
            // @ts-ignore
            isPresentation: ['fixed-ratio-large', 't-shape', 'fixed-ratio-small', 'free-type'].includes(project === null || project === void 0 ? void 0 : project.projectType)
        }); })) || [];
    }, [projects]);
    return (
    // @ts-ignore
    React.createElement(AspectRatio, { ratio: fixedRatio || WIDE_PRESENTATION_RATIO },
        React.createElement(GridDrag, { isProjectDrag: true, columnsNum: ((srcList === null || srcList === void 0 ? void 0 : srcList.length) === 1 && (srcList === null || srcList === void 0 ? void 0 : srcList.some(function (item) { return item === null || item === void 0 ? void 0 : item.isPresentation; }))) ? 1 : undefined, list: srcList, onSetSortedImg: onSetSortedProject, onImgRemove: onDeleteProject })));
};
//# sourceMappingURL=ProjectEditBlock.js.map